<template>
  <v-dialog
    v-model="dialogVisible"
    persistent
    max-width="370"
  >
    <v-card>
      <v-card-title class="headline" />
      <v-card-text>{{ descricao }}</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="error"
          @click="confirmAction()"
        >
          [E] Excluir
        </v-btn>
        <v-btn
          text
          color="grey"
          @click="toogleVisible()"
        >
          [C] Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogRemove',

  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    confirmAction: {
      type: Function,
      default: () => {},
    },
    toogleVisible: {
      type: Function,
      default: () => {},
    },
    descricao: {
      type: String,
      default: '',
    },
  },

  mounted() {
    document.addEventListener('keyup', this.onKeyPress);
  },

  destroyed() {
    document.removeEventListener('keyup', this.onKeyPress);
  },

  methods: {
    onKeyPress(e) {
      if (this.dialogVisible && e.key.toLowerCase() === 'e') {
        this.confirmAction();
      } else if (this.dialogVisible && (e.key.toLowerCase() === 'c' || e.key.toLowerCase() === 'escape')) {
        this.toogleVisible();
      }
    },
  },
};
</script>
